module.exports = __webpack_public_path__ + "pattern8.372dee6df561fd2ed153.png";


//////////////////
// WEBPACK FOOTER
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/assets/images/pattern8.png
// module id = ../../../../../src/assets/images/pattern8.png
// module chunks = styles